import React from 'react';
import PropTypes from 'prop-types';

const Container = ({ children, isFinished, animationDuration }) => (
  <div
    style={{
      opacity: isFinished ? 0 : 1,
      pointerEvents: 'none',
      transition: `opacity ${animationDuration}ms linear`,
    }}
  >
    {children}
  </div>
);

Container.propTypes = {
  children: PropTypes.object,
  isFinished: PropTypes.bool,
  animationDuration: PropTypes.number,
};

export default Container;
